/**
 * Format helpers shared across pages.
 */

export function formatPosts(n: number | null | undefined): string {
  if (n == null) return '—';
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${(n / 1000).toFixed(1)}k`;
  return `${(n / 1_000_000).toFixed(1)}M`;
}

export function formatUSD(amount: number | null | undefined): string {
  if (amount == null) return '—';
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: amount < 100 ? 2 : 0,
    maximumFractionDigits: 2
  });
}

export function formatChatId(chatId: string): string {
  // Telegram group ids are signed integers, often 13+ digits.
  // Show the first 4 + last 4 to keep tables tidy.
  if (chatId.length <= 10) return chatId;
  return `${chatId.slice(0, 5)}…${chatId.slice(-4)}`;
}

export function timeAgo(ts: number | null | undefined): string {
  if (!ts) return 'never';
  const ms = Date.now() - ts;
  if (ms < 0) return 'now';
  if (ms < 60_000) return `${Math.max(1, Math.round(ms / 1000))}s ago`;
  if (ms < 3_600_000) return `${Math.round(ms / 60_000)}m ago`;
  if (ms < 86_400_000) return `${Math.round(ms / 3_600_000)}h ago`;
  return `${Math.round(ms / 86_400_000)}d ago`;
}
